<script lang="ts" setup>
import { CrossCompactIcon, CheckIcon } from "tir-style-system/icons/outline";
import { TaskParameterModel } from "../models";
import { PropType, ref } from "vue";
import {
  TirPmInput,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-components";

/**Параметры */
const props = defineProps({
  /**Данные о настройке */
  data: { type: Object as PropType<TaskParameterModel>, default: () => new TaskParameterModel() },
  /**Скрыть удаление */
  hideRemove: { type: Boolean },
  /**Демонстрационный тег */
  preview: { type: Boolean, default: false },
});
/**События */
const emit = defineEmits<{
  /**Событие удаления параметра */
  (e: "remove"): void;
}>();

/**Активно редактирование */
const isEditing = ref(false);
/**Новое имя параметра */
const newName = ref();
/**Активно наведение */
const isHover = ref(false);

/**Переключение флага isHover */
const setHover = (_isHover) => {
  isHover.value = isEditing.value ? false : _isHover;
};
/**Переключение редактирования */
const editingParameter = (value) => {
  if (!props.preview) isEditing.value = value;
};
/**Смена имени параметра */
const changeName = (parameter: TaskParameterModel, name: string | number) => {
  parameter.Name = String(name);
  isEditing.value = false;
};
/**Запись имени параметра */
const setName = (value) => {
  newName.value = value;
};
</script>
<template>
  <div class="type-parameter" @mouseenter="setHover(true)" @mouseleave="setHover(false)">
    <div class="type-parameter_name">
      <span v-if="!isEditing" v-text="props.data.Name" @dblclick="editingParameter(true)" />
      <div class="type-parameter_input-block" v-if="isEditing && !preview">
        <TirPmInput
          class="type-parameter_input"
          :color="props.data.Color"
          :is-with-hint="false"
          @focus="editingParameter(true)"
          @blur="editingParameter(false)"
          @keyup.enter="changeName(props.data, newName ?? props.data.Name), editingParameter(false)"
          @keyup.esc="editingParameter(false)"
          :modelValue="data.Name"
          @input="setName($event)"
          isMicro
          autoFocus
        />
        <div class="type-parameter_divider" />
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          @mousedown.prevent
          @click.stop="changeName(props.data, newName ?? props.data.Name)"
          class="type-parameter_icon"
        >
          <template #leftSlot>
            <CheckIcon class="type-parameter_icon" />
          </template>
        </TirPmButton>
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          @mousedown.prevent
          @click.stop="editingParameter(false)"
          class="type-parameter_icon"
        >
          <template #leftSlot>
            <CrossCompactIcon class="type-parameter_icon" />
          </template>
        </TirPmButton>
      </div>
    </div>
    <template v-if="!hideRemove">
      <div class="type-parameter_divider" />
      <div class="type-parameter_delete" @click.stop="emit('remove')">
        <CrossCompactIcon />
      </div>
    </template>
  </div>
</template>
<style lang="scss" scoped>
.type-parameter {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  text-wrap: nowrap;
  height: 1.75rem;
  padding: 0 0.5rem;
  gap: 0.375rem;
  background-color: var(--neutral-translucent-10);
  cursor: pointer;

  &_name {
    color: var(--text-primary, #272d37);
    font-size: 0.875rem;
    font-weight: 400;
  }
  &_divider {
    height: 0.625rem;
    width: 0.1rem;
    margin-right: 0.42rem;
    background: var(--text-tertiary);
  }
  &_delete {
    width: 1.5rem;
    height: 1.5rem;
    color: var(--text-tertiary);
    cursor: pointer;
  }
  &_input-block {
    display: flex;
    align-items: center;
  }
  &_icon {
    width: 1rem;
    height: 1rem;
    color: var(--text-primary, #272d37);
  }
}
</style>
<style lang="scss">
.type-parameter_input {
  .input-container {
    border: none;
    height: 1.75rem !important;
    background-color: transparent;
    &:hover {
      border: none;
    }
  }
  .input-container__input-wrapper {
    margin: 0;
    height: 1.75rem !important;
  }
  .input-container__input {
    line-height: 1.75rem !important;
    font-size: 0.875rem;
    font-weight: 400;
    margin: 0;
  }
}
</style>
